/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Reply from '@spectrum-icons/workflow/Reply';
import ThumbUp from '@spectrum-icons/workflow/ThumbUp';
import { Avatar, RepliesContainer } from './CommentStyle';
import getUserInitials from '../../utils/getUserInitials';
import { getLocalDateTime } from '../../utils/utils';

function Replies(props) {
  const {
    replies,
    handleDateAndTime,
    workfrontEndpoint,
    repliesID,
    projectId,
  } = props;
  const { noteText, owner, entryDate } = replies;
  const [labelData, setLabelData] = useState(true);

  const toggleNameData = () => {
    setLabelData(!labelData);
  };

  return (
    <RepliesContainer>
      <div className="repliesMainComment">
        <div className="repliesHeadComment">
          <div className="repliesLogo">
            <Avatar>{getUserInitials(owner.name) || ''}</Avatar>
          </div>
          <div className="repliesNameParent">
            <span className="repliesNameSectionDp">
              {owner.name && labelData ? owner.name.slice(0, 15) : owner.name}
              <span onMouseOver={toggleNameData}>
                {labelData && owner.name && owner.name.length > 15 ? '...' : ''}
              </span>
            </span>
            <span className="repliesCommentDate">
              {handleDateAndTime(getLocalDateTime(entryDate))}
            </span>
          </div>
        </div>
        <div className="repliesCommentSection">
          <div className="repliesCommentBox">
            <div className="repliesTextArea">
              <a
                href={`${workfrontEndpoint}/project/${projectId}/updates?commentID=${repliesID}`}
                target="_blank"
                rel="noreferrer"
              >
                {noteText || ''}
              </a>
            </div>
            <div className="repliesIconArea">
              <span>
                <Reply size="XS" />
              </span>
              <span className="repliesSecondIcon">
                <ThumbUp size="XS" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </RepliesContainer>
  );
}

export default Replies;
